<script lang="ts">
  import Icon from '$shared/atoms/Icon/Icon.svelte';
  import WithList from '$shared/molecules/WithList/WithList.svelte';

  let showProfileMenu = $state(false);

  interface Props {
    list?: CommonList[];
    label?: string;
    onselect?: (menu: CommonList) => void;
  }

  let { list = [], label = '', onselect }: Props = $props();

  const onClickProfileButton = () => {
    showProfileMenu = !showProfileMenu;
  };

  const onClickProfileMenu = (menu: CommonList) => {
    onselect?.(menu);
    showProfileMenu = false;
  };

  const onProfileMenuClose = () => {
    showProfileMenu = false;
  };
</script>

<div class="comp-profile-button">
  <WithList
    {list}
    show={showProfileMenu}
    onclick={onClickProfileMenu}
    onclose={onProfileMenuClose}
    onopen={() => (showProfileMenu = true)}
  >
    <button
      type="button"
      class="profile-btn"
      class:active={showProfileMenu}
      onclick={onClickProfileButton}
    >
      <div class="label" title={label}>{label}</div>
      <div class="icon">
        <Icon value="icon-chevron-down {showProfileMenu && 'active'}" />
      </div>
    </button>
  </WithList>
</div>

<style>
  .comp-profile-button {
    position: relative;
  }
  .profile-btn {
    padding: 0 8px;
  }
  .profile-btn,
  .profile-btn .icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .profile-btn .label {
    margin-right: 8px;
    line-height: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 110px;
  }
  .profile-btn.active {
    background-color: var(--light-blue);
    color: var(--blue);
    border-color: var(--light-blue);
  }
</style>
